import { render, staticRenderFns } from "./planpad.vue?vue&type=template&id=5d8f87b6&scoped=true&"
import script from "./planpad.vue?vue&type=script&lang=js&"
export * from "./planpad.vue?vue&type=script&lang=js&"
import style0 from "./planpad.vue?vue&type=style&index=0&id=5d8f87b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f87b6",
  null
  
)

export default component.exports